import React from "react";
import { bool } from "prop-types";

import useFeatureState from "../../utilities/hooks/useFeatureState";
import useReducerActions from "../../utilities/useReducerActions";
import Deals from "../Deals";
import ExpertInfoExpanded from "../ExpertInfoExpanded";
import Modal from "../Modal";

const ExpertModal = ({ isModal }) => {
  const { modalAgent: expert } = useFeatureState();
  const { dispatchResetModalAgent } = useReducerActions();

  const contact = expert?.contact;

  const handleModalClose = () => dispatchResetModalAgent();

  return expert ? (
    <Modal
      // TODO FOS-1638: do we still need two attributes for specs?
      data-qa={`${isModal ? "mobile" : "desktop"}-expert-deals-modal`}
      isOpen
      onRequestClose={handleModalClose}
      theme="classicBlueHeader"
    >
      <Modal.ModalTitle data-qa="expert-modal-title">
        {contact.profile.name}&apos;s Deals
      </Modal.ModalTitle>
      <Modal.ModalBody>
        <Modal.ModalLeft data-qa="deals-details">
          <Deals contact={contact} />
        </Modal.ModalLeft>
        <Modal.ModalRight data-qa="expert-details">
          <ExpertInfoExpanded expert={expert} />
        </Modal.ModalRight>
      </Modal.ModalBody>
    </Modal>
  ) : null;
};

ExpertModal.propTypes = {
  isModal: bool
};

ExpertModal.defaultProps = {
  isModal: false
};

export default ExpertModal;
